import { Component } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { LayoutCollapseSideNavAction } from '@client/actions/layout-actions';
import {
	getLayoutEnableAdminOptions,
	getLayoutIsAdminMenu,
	getLayoutScopeId,
	getOrganizationAll,
	getOrganizationById
} from '@client/selectors';
import { select, Store } from '@ngrx/store';
import * as _moment from 'moment'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { Subscription } from 'rxjs';
import { map, mergeMap, switchMap, take } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { OrganizationsService } from '@client/core/services/organization.service';

@Component({
	selector: 'spaq-layout-account-header',
	template: `
		<nav
			*ngIf="(enableAdminOptions$ | async) === false"
			class="navbar-bg navbar navbar-expand px-4"
			style="background-color: #00000030"
		>
			<i (click)="collapse()" aria-hidden="true" id="collapseMenu" class="fa fa-bars fa-2x text-white"></i>
		</nav>
		<nav *ngIf="enableAdminOptions$ | async" class="navbar navbar px-4" style="background-color: #00000030">
			<i (click)="collapse()" aria-hidden="true" id="collapseMenu" class="fa fa-bars fa-2x text-white"></i>

			<div class="ml-auto" href="#">
				<kendo-dropdownbutton
					[data]="organizationList$ | async"
					[textField]="'organizationName'"
					[popupSettings]="{ animate: true, align: 'right' }"
					(itemClick)="onOrganizationClick($event)"
				>
					{{ organization$ | async }}
					<ng-template kendoDropDownButtonItemTemplate let-dataItem>
						<span *ngIf="(scopeId$ | async) === dataItem.organizationCode" class="k-icon k-i-check"></span>
						<span *ngIf="(scopeId$ | async) !== dataItem.organizationCode" class="k-icon"></span>
						<span>{{ dataItem.organizationName }}</span>
					</ng-template>
				</kendo-dropdownbutton>
			</div>
		</nav>
		<nav *ngIf="(isAdminMenu$ | async) && (enableAdminOptions$ | async)" class="navbar navbar justify-content-start px-4 bg-white py-3">
			<kendo-combobox
				[style.max-width.px]="390"
				[data]="adminOrganizationList$ | async"
				valueField="organizationCode"
				textField="organizationName"
				(valueChange)="organizationService.changeOrganization($event)"
				[value]="adminSelectedOrganization$ | async"
				class="me-4"
			></kendo-combobox>
			<kendo-combobox
				*ngIf="organizationService.isGroupSelection"
				[disabled]="
					(adminSelectedOrganizationGroups$ | async).length === 1 || !(adminSelectedOrganization$ | async).organizationCode
				"
				[style.max-width.px]="390"
				[data]="adminSelectedOrganizationGroups$ | async"
				valueField="groupCode"
				textField="groupDescription"
				(valueChange)="organizationService.changeGroup($event)"
				[value]="adminSelectedGroup$ | async"
			></kendo-combobox>
		</nav>
	`,
	styleUrls: ['./layout-account-header.component.scss']
})
export class LayoutAccountHeaderComponent {
	adminOrganizationList$ = this.organizationService.getAll(true);
	adminSelectedOrganization$ = this.organizationService.selectedOrganization$;
	adminSelectedGroup$ = this.organizationService.selectedGroup$;
	adminSelectedOrganizationGroups$ = this.organizationService.getSelectedOrganizationGroups(true);

	isAdminMenu$ = this.store.pipe(select(getLayoutIsAdminMenu));
	scopeId$ = this.store.pipe(select(getLayoutScopeId));
	organization$ = this.scopeId$.pipe(
		switchMap(id =>
			this.store.pipe(
				select(getOrganizationById, id),
				map(x => (x && x.organizationName) || 'Public')
			)
		)
	);
	organizationList$ = this.store.pipe(
		select(getOrganizationAll),
		map(x => [...x])
	);
	enableAdminOptions$ = this.store.pipe(select(getLayoutEnableAdminOptions));
	states = {
		error: 0,
		success: 0,
		pending: 0
	};
	status = {
		idle: false,
		payment: false,
		vault: false,
		contract: false,
		pdf: false,
		preauth: false
	};
	subscription: Subscription;

	constructor(
		public organizationService: OrganizationsService,
		private db: AngularFireDatabase,
		private afAuth: AngularFireAuth,
		private store: Store<any>
	) {}
	onOrganizationClick(organization: any) {
		if (!organization.organizationCode) {
			localStorage.removeItem('selectedOrganization');
			return this.afAuth.user
				.pipe(
					take(1),
					mergeMap(u => [
						this.db
							.list(`/user/${u.uid}/vehicles`)
							.valueChanges()
							.pipe(
								switchMap(x => {
									return this.db.object(`/user/${u.uid}/contract`).set({ deleted: true, vehicles: x });
								})
							)
							.toPromise(),
						this.db.object(`/user/${u.uid}/access-code`).set(null),
						this.db.object(`/user/${u.uid}/subscription/custom`).set(null)
					]),
					take(1)
				)
				.subscribe(() => {
					location.reload();
				});
		}
		localStorage.setItem('selectedOrganization', organization.organizationCode);
		return this.afAuth.user
			.pipe(
				take(1),
				mergeMap(u => [
					this.db
						.list(`/user/${u.uid}/vehicles`)
						.valueChanges()
						.pipe(
							switchMap(x => {
								return this.db.object(`/user/${u.uid}/contract`).set({ deleted: true, vehicles: x });
							})
						)
						.toPromise(),
					this.db.object(`/user/${u.uid}/access-code`).set(null),
					this.db.object(`/user/${u.uid}/subscription/custom`).set(null)
				]),
				take(1)
			)
			.subscribe(() => {
				location.reload();
			});
	}
	collapse() {
		this.store.dispatch(new LayoutCollapseSideNavAction(null, Date.now()));
	}
}
